import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';

import {
  toggleModal
} from './actions';

import ModalForm from './ModalForm';

import './styles.scss';

export const AddPlant = ({
  modal,
  toggleModal
}) => {
  return (
    <>
      <Button
        color="primary"
        onClick={toggleModal.bind(this, !modal)}
        size="sm"
      >
        Add Plant
      </Button>
      <Modal
        centered={true}
        className="add-plant-modal"
        isOpen={modal}
        toggle={toggleModal.bind(this, !modal)}
      >
       <ModalHeader>Add Plant</ModalHeader>
       <ModalBody>
          <ModalForm />
       </ModalBody>
     </Modal>
    </>
  );
}

const mapStateToProps = state => ({
  modal: state.addPlant.modal
});

const mapDispatchToProps = dispatch => bindActionCreators({
  toggleModal
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AddPlant);
